// textbox — static text. PBI sometimes stores text in spec.text; if not,
// the backend may inject a `data.value` rendering.

import type { VisualProps } from "./types";
import "./_static.css";

export function TextboxVisual({ spec, data }: VisualProps) {
  const text = spec.text ?? data.formatted ?? spec.title ?? "";
  return (
    <div className="static-card static-textbox">
      <div className="static-textbox-body">{text}</div>
    </div>
  );
}
